export default {
    // 全量数据
    projectAllList: [],
    siteAllList: [],
    classmateAllList: [],
    // 显示的数据
    projectList: [],
    siteList: [],
    classmateList: [],
    // 设置项目相关的数据
    setProjectInfo(projectList, siteList, classmateList) {
        if (projectList && projectList.length > 0) {
          this.projectList = projectList;
          this.projectAllList = [...projectList];
        }
        if (siteList && siteList.length > 0) {
          this.siteList = siteList;
          this.siteAllList = [...siteList];
        }
        if (classmateList && classmateList.length > 0) {
          this.classmateList = classmateList;
          this.classmateAllList = [...classmateList];
        }
    },
    // 当项目变更时，工地和班组变更
    changeProjectId(projectId) {
        // 这里不能用=，只能用splice和push
        this.siteList.splice(0, this.siteList.length);
        this.classmateList.splice(0, this.classmateList.length);
        // 这些工地是项目下的所有工地
        for (let i = 0; i < this.siteAllList.length; i++) {
            if (projectId === this.siteAllList[i].projectId || !projectId) {
                this.siteList.push(this.siteAllList[i]);
            }
        }
        // 这些班组是项目下的班组
        for (let i = 0; i < this.classmateAllList.length; i++) {
            if (projectId === this.classmateAllList[i].projectId || !projectId) {
                this.classmateList.push(this.classmateAllList[i]);
            }
        }
    },
    // 当工地变更时，项目和班组数据变更
    changeSiteId(siteId) {
        // 这里不能用=，只能用splice和push
        this.classmateList.splice(0, this.classmateList.length);
        // 这些班组是工地下的班组
        for (let i = 0; i < this.classmateAllList.length; i++) {
            if (siteId === this.classmateAllList[i].siteId || !siteId) {
                this.classmateList.push(this.classmateAllList[i]);
            }
        }
        // 找到这个工地，返回
        return siteId? this.siteList.find(item => item.id === siteId) : {};
    },
    // 当班组变更时，项目和工地数据变更
    changeClassmateId(classmateId) {
        // 找到这个班组，返回
        return classmateId? this.classmateList.find(item => item.id === classmateId) : {};
    }

}